//import Store from "../";
//import Mutations from "../mutations";
import { Promise } from "es6-promise";
import common from "../api/ajax";
import utils from '@/lib/utils';

const bookingModule = {
  namespaced: true,
  state: {
    bookingFees: []
  },
  getters: {
    BOOKING_FEE_LIST: state => {
      return state.bookingFees;
    }
  },
  mutations: {
    GET_BOOKING_FEE_LIST: (state, payload) => {
      let bookingFees = payload;
      state.bookingFees = bookingFees;
    }
  },
  actions: {
    GET_BOOKING_FEE_LIST: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.getRequest(
          `/api/v1/${utils.getProjectId()}/bookingfee/`,
          payload,
          function(res) {
            context.commit("GET_BOOKING_FEE_LIST", res.data);
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    ADD_BOOKING_PAYMENT: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.postRequest(
          `/api/v1/${utils.getProjectId()}/bookingpayment/`,
          payload,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    SAVE_BOOKING_PAYMENT: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.putRequest(
          `/api/v1/${utils.getProjectId()}/bookingpayment/${payload.id}/`,
          payload.data,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    DELETE_BOOKING_PAYMENT: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.deleteRequest(
          `/api/v1/${utils.getProjectId()}/bookingpayment/${payload.id}/`,
          {},
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    GET_BOOKING_PAYMENT_DETAILS: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.getRequest(
          `/api/v1/${utils.getProjectId()}/bookingpayment/${payload.id}/`,
          {},
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    GET_SERVICES_BOOKING: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.getRequest(
          `/api/v1/${utils.getProjectId()}/servicebooking/get_services_apartment/`,
          payload,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    SEND_EMAIL_CONFIRMED_BOOKING: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.postRequest(
          `/api/v1/${utils.getProjectId()}/bookingpayment/send_email_confirmed_booking/`,
          payload,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    ADD_APARTMENT_CLEANING_SERVICE: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.postRequest(
          `/api/v1/${utils.getProjectId()}/apartmentcleaningservice/`,
          payload,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    },
    UPDATE_APARTMENT_CLEANING_SERVICE: (context, payload) => {
      return new Promise((resolve, reject) => {
        common.putRequest(
          `/api/v1/${utils.getProjectId()}/apartmentcleaningservice/${payload.id}/`,
          payload.data,
          function(res) {
            resolve(res.data);
          },
          function(error) {
            reject(error);
          }
        );
      });
    }
  }
};
export default bookingModule;



// WEBPACK FOOTER //
// ./src/store/modules/booking.js